export const enum myAgencyTalentFiltersTrackId {
  verticalList = 'foam-myagency-talentFilters-verticalsList',
  gendersList = 'foam-myagency-talentFilters-gendersList',
  platformsList = 'foam-myagency-talentFilters-platformsList',
  location = 'foam-myagency-talentFilters-location',
  age = 'foam-myagency-talentFilters-age',
  audienceFilterIGFollowers = 'foam-myagency-audiencefilter-instagram-followers',
  audienceFilterTTFollowers = 'foam-myagency-audiencefilter-tiktok-followers',
  audienceFilterYTFollowers = 'foam-myagency-audiencefilter-youtube-subscribers',
  audienceFilterSCFollowers = 'foam-myagency-audiencefilter-snapchat-followers',
}

export const enum creatorMarketerTalentFiltersTrackId {
  verticalList = 'foam-creatormarketer-talentFilters-verticalsList',
  gendersList = 'foam-creatormarketer-talentFilters-gendersList',
  platformsList = 'foam-creatormarketer-talentFilters-platformsList',
  location = 'foam-creatormarketer-talentFilters-location',
  age = 'foam-creatormarketer-talentFilters-age',
  audienceFilterIGFollowers = 'foam-creatormarketer-audiencefilter-instagram-followers',
  audienceFilterTTFollowers = 'foam-creatormarketer-audiencefilter-tiktok-followers',
  audienceFilterYTFollowers = 'foam-creatormarketer-audiencefilter-youtube-subscribers',
  audienceFilterSCFollowers = 'foam-creatormarketer-audiencefilter-snapchat-followers',
}
